import { Component, OnInit } from '@angular/core';
import { authManager } from '@authmanager/authManager';
import { AdminService } from '@adminservice/admin.service';
import { environment } from '@environment/environment';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor() {
    
  }
  
  ngOnInit() {

  }
  

}
